// KPICodesTab.jsx
import React, { useState } from "react";
import { KPICodeAddForm } from "./KPICodeAddForm";
import { KPICodeList } from "./KPICodeList";
import { validateCode, validateNewCode } from "./utils/validation";

export function KPICodesTab({
  form,
  handleAddCode,
  handleRemoveCode,
  handleCodeChange
}) {
  const [errorState, setErrorState] = useState([]);
  const [editingCodeId, setEditingCodeId] = useState(null);
  const [newCodeForm, setNewCodeForm] = useState({
    code: "",
    description: "",
    rating: ""
  });

  const handleAddNewCode = () => {
    const errors = validateNewCode(newCodeForm);
    
    if (Object.keys(errors).length > 0) {
      setErrorState([{ ...errors }]);
      return;
    }

    // Check for duplicate code
    const isDuplicate = form.performanceRatingDefinitions.some(code => 
      code.code.toLowerCase() === newCodeForm.code.toLowerCase()
    );

    if (isDuplicate) {
      setErrorState([{ code: 'Code already exists' }]);
      return;
    }

    // Use the parent's handleAddCode function
    handleAddCode({
      code: newCodeForm.code.trim(),
      description: newCodeForm.description.trim(),
      rating: parseInt(newCodeForm.rating)
    });
    
    // Reset form and clear errors
    setNewCodeForm({
      code: "",
      description: "",
      rating: ""
    });
    setErrorState([]);
  };

  const handleStartEdit = (index) => {
    setEditingCodeId(index);
    setErrorState([]);
  };

  const handleSaveEdit = () => {
    // Validate the current code being edited
    const code = form.performanceRatingDefinitions[editingCodeId];
    const errors = validateCode(code);
    
    if (Object.keys(errors).length > 0) {
      setErrorState([{ ...errors }]);
      return;
    }

    // Check for duplicate code (excluding current editing code)
    const isDuplicate = form.performanceRatingDefinitions.some((c, index) => 
      index !== editingCodeId && 
      c.code.toLowerCase() === code.code.toLowerCase()
    );

    if (isDuplicate) {
      setErrorState([{ code: 'Code already exists' }]);
      return;
    }

    // Exit edit mode
    setEditingCodeId(null);
    setErrorState([]);
  };

  const handleCancelEdit = () => {
    setEditingCodeId(null);
    setErrorState([]);
  };

  const handleRemoveCodeClick = (index) => {
    if (editingCodeId === index) {
      setEditingCodeId(null);
    }
    handleRemoveCode(index);
    setErrorState([]);
  };

  return (
    <div className="space-y-4">
      <div className="rounded-lg border border-gray-300 bg-white p-4 shadow-sm">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-medium text-gray-700">KPI Codes</h3>
          <div className="text-sm text-gray-600">
            <span className="font-medium">Total Codes:</span> {form.performanceRatingDefinitions.length}
          </div>
        </div>

        {/* Add New Code Form */}
        <KPICodeAddForm
          newCodeForm={newCodeForm}
          setNewCodeForm={setNewCodeForm}
          errorState={errorState}
          onAddCode={handleAddNewCode}
        />

        {/* Existing Codes List */}
        <KPICodeList
          performanceRatingDefinitions={form.performanceRatingDefinitions}
          editingCodeId={editingCodeId}
          errorState={errorState}
          onStartEdit={handleStartEdit}
          onSaveEdit={handleSaveEdit}
          onCancelEdit={handleCancelEdit}
          onRemoveCode={handleRemoveCodeClick}
          onCodeChange={handleCodeChange}
        />
      </div>
    </div>
  );
}